import TrackerSDK from '@ns-track/core'
import store from '@store'
import router from '@/router'

const track = new TrackerSDK({
  serverUrl: process.env.VUE_APP_API_TRACK, // 必须：数据上报地址
  appId: 'jmsmx-vip', // 必须：应用标识
  appName: '墨西哥VIP', // 必须：应用标识
  batchSize: 10,
  batchDelay: 500,
})

export function pvTrack(to, from) {
  try {
    setTimeout(() => {
      const { user } = store.state.base
      track.pvTrack({
        routeName: to.name,
        referrer: from.name,
        pageTitle: to.meta.title || document.title,
        userId: user?.account,
        userName: user?.customerName
      })
    })
  } catch (error) {
    console.log('error', error)
  }
}

export function eventTrack(eventCode, eventName) {
  try {
    setTimeout(() => {
      const { user } = store.state.base
      const route = router.currentRoute
      track.track(eventCode, eventName, {
        routeName: route.name,
        pageTitle: route.meta.title || document.title,
        userId: user?.account,
        userName: user?.customerName
      })
    })
  } catch (error) {
    console.log('error', error)
  }
}
